// import React, { useState, useRef, useEffect } from "react";
// import axios from "axios";
// import { toast } from "react-hot-toast";
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// import { FcGoogle } from "react-icons/fc";
// import { Link, useNavigate } from "react-router-dom";
// import SummaryApi from "../common/SummaryApi";

// const SignUp = () => {
//   const navigate = useNavigate();
//   const otpInputRefs = useRef([]);

//   const [step, setStep] = useState(1); // 1 = Email, 2 = OTP & Password
//   const [loading, setLoading] = useState(false);
  
//   // Form Data
//   const [email, setEmail] = useState("");
//   const [otp, setOtp] = useState(["", "", "", ""]); 
//   const [password, setPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");

//   // Visibility Toggles
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);

//   // Focus first OTP input when stepping into step 2
//   useEffect(() => {
//     if (step === 2) {
//       setTimeout(() => {
//         otpInputRefs.current[0]?.focus();
//       }, 100);
//     }
//   }, [step]);

//   // --- STEP 1: SEND OTP ---
//   const handleSendOtp = async (e) => {
//     if (e) e.preventDefault();

//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!emailRegex.test(email)) {
//       toast.error("Please enter a valid email address");
//       return;
//     }

//     setLoading(true);
//     try {
//       const response = await axios.post(SummaryApi.register.url, { email });
//       if (response.data.success) {
//         toast.success(response.data.message);
//         setStep(2);
//       }
//     } catch (error) {
//       toast.error(error.response?.data?.message || "Failed to send OTP");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleResendOtp = () => {
//     setOtp(["", "", "", ""]); 
//     handleSendOtp();
//     setTimeout(() => {
//         otpInputRefs.current[0]?.focus();
//     }, 100);
//   };

//   // --- STEP 2: VERIFY & REGISTER ---
//   const handleVerifyAndRegister = async (e) => {
//     e.preventDefault();

//     const otpString = otp.join("");
//     if (otpString.length !== 4) {
//       toast.error("Please enter the complete 4-digit OTP");
//       return;
//     }

//     if (password.length < 6) {
//       toast.error("Password must be at least 6 characters");
//       return;
//     }

//     if (password !== confirmPassword) {
//       toast.error("Passwords do not match");
//       return;
//     }

//     setLoading(true);
//     try {
//       const payload = {
//         email,
//         otp: otpString,
//         password: password
//       };

//       const response = await axios.post(SummaryApi.verifyOtp.url, payload);

//       if (response.data.success) {
//         toast.success("Account created successfully!");
//         setTimeout(() => {
//             navigate("/login");
//         }, 1500);
//       }
//     } catch (error) {
//       toast.error(error.response?.data?.message || "Verification failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // --- OTP INPUT LOGIC ---

//   const handleOtpChange = (value, index) => {
//     if (isNaN(value)) return;
//     const newOtp = [...otp];
//     newOtp[index] = value.substring(value.length - 1);
//     setOtp(newOtp);
//     if (value && index < 3) {
//       otpInputRefs.current[index + 1].focus();
//     }
//   };

//   const handleOtpKeyDown = (e, index) => {
//     // Backspace
//     if (e.key === "Backspace") {
//       if (!otp[index] && index > 0) {
//         otpInputRefs.current[index - 1].focus();
//       }
//     }
//     // Arrows
//     if (e.key === "ArrowLeft" && index > 0) {
//       e.preventDefault();
//       otpInputRefs.current[index - 1].focus();
//     }
//     if (e.key === "ArrowRight" && index < 3) {
//       e.preventDefault();
//       otpInputRefs.current[index + 1].focus();
//     }
//   };

//   // NEW: Handle Copy/Paste
//   const handleOtpPaste = (e, startIndex) => {
//     e.preventDefault();
//     const data = e.clipboardData.getData("text");
    
//     // Filter non-numeric characters
//     const cleanData = data.replace(/[^0-9]/g, "");

//     if (!cleanData) return;

//     const newOtp = [...otp];
//     let lastFilledIndex = startIndex;

//     // Distribute pasted digits starting from the focused input
//     for (let i = 0; i < cleanData.length; i++) {
//         const targetIndex = startIndex + i;
//         if (targetIndex < 4) {
//             newOtp[targetIndex] = cleanData[i];
//             lastFilledIndex = targetIndex;
//         }
//     }

//     setOtp(newOtp);
    
//     // Focus the last input that was filled
//     if (otpInputRefs.current[lastFilledIndex]) {
//         otpInputRefs.current[lastFilledIndex].focus();
//     }
//   };

//   // --- SHARED CLASSES ---
//   const inputClasses = "block px-4 py-3 w-full text-sm text-gray-900 bg-blue-50 rounded-md border-2 border-blue-200 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer placeholder-transparent";
//   const labelClasses = "absolute text-sm duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] left-3 bg-white px-2 text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-[-50%] peer-placeholder-shown:top-1/2 peer-placeholder-shown:bg-transparent peer-placeholder-shown:text-gray-500 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:bg-white peer-focus:px-2 peer-focus:text-blue-600";

//   return (
//     <div className="min-h-screen bg-[#bfdaf9] font-sans text-gray-800 flex flex-col">
//       <main className="flex-1 flex items-center justify-center p-4">
//         <div className="bg-white w-full max-w-[500px] rounded-sm shadow-xl p-8 md:px-12 md:py-10 text-center relative">
          
//           {step === 1 ? (
//             /* --- STEP 1: EMAIL INPUT --- */
//             <div className="animate-fade-in">
//               <h2 className="text-2xl font-bold mb-8 text-black">Create Account</h2>
//               <form onSubmit={handleSendOtp}>
//                 <div className="relative mb-6 text-left">
//                   <div className="relative">
//                     <input
//                       type="email"
//                       id="email"
//                       className={inputClasses}
//                       placeholder=" "
//                       value={email}
//                       onChange={(e) => setEmail(e.target.value)}
//                       required
//                     />
//                     <label htmlFor="email" className={labelClasses}>
//                       Email Address
//                     </label>
//                   </div>
//                 </div>

//                 <button
//                   type="submit"
//                   disabled={loading}
//                   className="w-full text-white bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-3 text-center mb-6 transition-colors"
//                 >
//                   {loading ? "Sending OTP..." : "Continue"}
//                 </button>
//               </form>

//               {/* Social Login */}
//               <div className="relative flex py-2 items-center mb-6">
//                 <div className="flex-grow border-t border-gray-300"></div>
//                 <span className="flex-shrink-0 px-2 text-gray-500 text-sm">OR</span>
//                 <div className="flex-grow border-t border-gray-300"></div>
//               </div>
//               <div className="flex justify-center space-x-6 mb-6">
//                 {/* <button className="p-2 rounded-full hover:bg-gray-100"><FaFacebook className="w-8 h-8 text-blue-600" /></button>
//                 <button className="p-2 rounded-full hover:bg-gray-100"><FaApple className="w-8 h-8 text-black" /></button> */}
//                 <button type="button" className="text-red-500 text-3xl hover:opacity-80 transition">
//                                   <FcGoogle />
//                                 </button>
//               </div>
//               <div className="text-sm text-gray-500">
//                 Already have an account? <Link to="/login" className="text-blue-600 font-semibold underline">Sign in</Link>
//               </div>
//             </div>
//           ) : (
//             /* --- STEP 2: OTP & PASSWORD --- */
//             <div className="animate-fade-in">
//               <div className="flex justify-center mb-4">
//                  <svg className="w-16 h-16 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"/></svg>
//               </div>

//               <h2 className="text-xl font-bold mb-2 text-black">OTP Verification</h2>
//               <p className="text-xs text-gray-800 font-medium mb-1">
//                 Enter the OTP sent to {email}
//               </p>
//               <button onClick={() => setStep(1)} className="text-xs text-blue-500 font-medium hover:underline mb-6">
//                 Change Email
//               </button>

//               <form onSubmit={handleVerifyAndRegister}>
//                 {/* OTP Inputs */}
//                 <div className="flex justify-center gap-4 mb-6">
//                   {otp.map((digit, index) => (
//                     <input
//                       key={index}
//                       ref={(el) => (otpInputRefs.current[index] = el)}
//                       type="text"
//                       maxLength={1}
//                       value={digit}
//                       onChange={(e) => handleOtpChange(e.target.value, index)}
//                       onKeyDown={(e) => handleOtpKeyDown(e, index)}
//                       onPaste={(e) => handleOtpPaste(e, index)} // ADDED PASTE HANDLER
//                       className="w-10 h-10 text-center text-xl font-bold text-gray-800 border-b-2 border-gray-400 focus:border-blue-600 focus:outline-none bg-transparent"
//                     />
//                   ))}
//                 </div>

//                 {/* Password Fields */}
//                 <div className="space-y-6 mb-6 text-left">
                  
//                   {/* New Password */}
//                   <div className="relative">
//                      <div className="relative">
//                        <input
//                         type={showPassword ? "text" : "password"}
//                         id="new-password"
//                         className={`${inputClasses} pr-10`} 
//                         placeholder=" "
//                         value={password}
//                         onChange={(e) => setPassword(e.target.value)}
//                         required
//                        />
//                        <label htmlFor="new-password" className={labelClasses}>
//                          New Password
//                        </label>
                       
//                        <button
//                           type="button"
//                           onClick={() => setShowPassword(!showPassword)}
//                           className="absolute inset-y-0 right-0 px-3 flex items-center text-gray-400 hover:text-blue-600 focus:outline-none z-20"
//                        >
//                           {showPassword ? <FaEyeSlash /> : <FaEye />}
//                        </button>
//                      </div>
//                   </div>

//                   {/* Confirm Password */}
//                   <div className="relative">
//                      <div className="relative">
//                        <input
//                         type={showConfirmPassword ? "text" : "password"}
//                         id="confirm-password"
//                         className={`${inputClasses} pr-10`}
//                         placeholder=" "
//                         value={confirmPassword}
//                         onChange={(e) => setConfirmPassword(e.target.value)}
//                         required
//                        />
//                        <label htmlFor="confirm-password" className={labelClasses}>
//                          Confirm Password
//                        </label>

//                        <button
//                           type="button"
//                           onClick={() => setShowConfirmPassword(!showConfirmPassword)}
//                           className="absolute inset-y-0 right-0 px-3 flex items-center text-gray-400 hover:text-blue-600 focus:outline-none z-20"
//                        >
//                           {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
//                        </button>
//                      </div>
//                   </div>
//                 </div>

//                 <div className="text-xs text-gray-500 mb-6">
//                   Didn't receive the OTP? <button type="button" onClick={handleResendOtp} className="text-blue-500 font-medium hover:underline">Resend OTP</button>
//                 </div>

//                 <button
//                   type="submit"
//                   disabled={loading}
//                   className="w-full text-white bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-3 text-center mb-6 transition-colors"
//                 >
//                   {loading ? "Verifying..." : "Confirm & Register"}
//                 </button>
//               </form>
//             </div>
//           )}

//           <div className="mt-8 text-[10px] md:text-[12px] text-gray-500">
//             By proceeding, you acknowledge and accept Regeestex{' '}
//             <Link 
//               to="/terms-and-conditions" 
//               target="_blank" 
//               rel="noopener noreferrer"
//               className="underline hover:text-black transition-colors font-medium"
//             >
//               Terms of Use
//             </Link>
//             {' '}and{' '}
//             <Link 
//               to="/privacy-policy" 
//               target="_blank" 
//               rel="noopener noreferrer"
//               className="underline hover:text-black transition-colors font-medium"
//             >
//               Privacy Policy
//             </Link>.
//           </div>
//         </div>
//       </main>
//     </div>
//   );
// };

// export default SignUp;

import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { toast } from "react-hot-toast";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";
import { FaFacebook } from "react-icons/fa6"; // Added FaFacebook
import { Link, useNavigate } from "react-router-dom";
import SummaryApi from "../common/SummaryApi";

// --- Imports needed for Social Login Logic ---
import { useDispatch } from "react-redux";
import { setUserDetails } from "../store/userSlice";
import { useCart } from "../context/CartContext";
import { mergeGuestCart } from "../helpers/cartHelper";
import { useGoogleLogin } from "@react-oauth/google";
import FacebookLogin from "@greatsumini/react-facebook-login";

const SignUp = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch(); // Added for Redux
  const { refreshCart } = useCart(); // Added for Cart

  const otpInputRefs = useRef([]);

  const [step, setStep] = useState(1); // 1 = Email, 2 = OTP & Password
  const [loading, setLoading] = useState(false);
  
  // Form Data
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState(["", "", "", ""]); 
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  // Visibility Toggles
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // Focus first OTP input when stepping into step 2
  useEffect(() => {
    if (step === 2) {
      setTimeout(() => {
        otpInputRefs.current[0]?.focus();
      }, 100);
    }
  }, [step]);

  // ==========================================
  //  SOCIAL LOGIN / SIGNUP LOGIC (Added)
  // ==========================================

  // Helper to handle post-login/signup actions (Redux, Cart, Redirect)
  const handleSocialAuthSuccess = async (token, providerName) => {
    try {
      // 1. Store Token
      localStorage.setItem("token", token);

      // 2. Fetch User Profile
      const userRes = await axios.get(SummaryApi.getProfile.url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // 3. Update Redux
      dispatch(setUserDetails(userRes?.data?.data));

      // 4. Merge & Refresh Cart
      await mergeGuestCart(token);
      refreshCart();

      // 5. Notify & Redirect
      toast.success(`${providerName} successful!`);
      navigate("/"); // Redirect to home after signup

    } catch (error) {
      console.error(`Error during ${providerName} post-processing:`, error);
      toast.error(`Failed to load user profile after ${providerName}.`);
    }
  };

  // Google Hook
  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        const res = await axios.post(
          SummaryApi.googleLogin.url,
          { accessToken: tokenResponse.access_token }
        );
        // Call the helper
        await handleSocialAuthSuccess(res.data.token, "Google Signup");
      } catch (err) {
        console.error("Google API Error:", err);
        toast.error("Google signup failed");
      }
    },
    onError: () => {
      toast.error("Google Signup Failed");
    },
  });

  // ==========================================
  //  MANUAL SIGNUP LOGIC (Existing)
  // ==========================================

  // --- STEP 1: SEND OTP ---
  const handleSendOtp = async (e) => {
    if (e) e.preventDefault();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(SummaryApi.register.url, { email });
      if (response.data.success) {
        toast.success(response.data.message);
        setStep(2);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to send OTP");
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = () => {
    setOtp(["", "", "", ""]); 
    handleSendOtp();
    setTimeout(() => {
        otpInputRefs.current[0]?.focus();
    }, 100);
  };

  // --- STEP 2: VERIFY & REGISTER ---
  const handleVerifyAndRegister = async (e) => {
    e.preventDefault();

    const otpString = otp.join("");
    if (otpString.length !== 4) {
      toast.error("Please enter the complete 4-digit OTP");
      return;
    }

    if (password.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    setLoading(true);
    try {
      const payload = {
        email,
        otp: otpString,
        password: password
      };

      const response = await axios.post(SummaryApi.verifyOtp.url, payload);

      if (response.data.success) {
        toast.success("Account created successfully!");
        setTimeout(() => {
            navigate("/login");
        }, 1500);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Verification failed");
    } finally {
      setLoading(false);
    }
  };

  // --- OTP INPUT LOGIC ---

  const handleOtpChange = (value, index) => {
    if (isNaN(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value.substring(value.length - 1);
    setOtp(newOtp);
    if (value && index < 3) {
      otpInputRefs.current[index + 1].focus();
    }
  };

  const handleOtpKeyDown = (e, index) => {
    // Backspace
    if (e.key === "Backspace") {
      if (!otp[index] && index > 0) {
        otpInputRefs.current[index - 1].focus();
      }
    }
    // Arrows
    if (e.key === "ArrowLeft" && index > 0) {
      e.preventDefault();
      otpInputRefs.current[index - 1].focus();
    }
    if (e.key === "ArrowRight" && index < 3) {
      e.preventDefault();
      otpInputRefs.current[index + 1].focus();
    }
  };

  // Handle Copy/Paste
  const handleOtpPaste = (e, startIndex) => {
    e.preventDefault();
    const data = e.clipboardData.getData("text");
    
    // Filter non-numeric characters
    const cleanData = data.replace(/[^0-9]/g, "");

    if (!cleanData) return;

    const newOtp = [...otp];
    let lastFilledIndex = startIndex;

    // Distribute pasted digits starting from the focused input
    for (let i = 0; i < cleanData.length; i++) {
        const targetIndex = startIndex + i;
        if (targetIndex < 4) {
            newOtp[targetIndex] = cleanData[i];
            lastFilledIndex = targetIndex;
        }
    }

    setOtp(newOtp);
    
    // Focus the last input that was filled
    if (otpInputRefs.current[lastFilledIndex]) {
        otpInputRefs.current[lastFilledIndex].focus();
    }
  };

  // --- SHARED CLASSES ---
  const inputClasses = "block px-4 py-3 w-full text-sm text-gray-900 bg-blue-50 rounded-md border-2 border-blue-200 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer placeholder-transparent";
  const labelClasses = "absolute text-sm duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] left-3 bg-white px-2 text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-[-50%] peer-placeholder-shown:top-1/2 peer-placeholder-shown:bg-transparent peer-placeholder-shown:text-gray-500 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:bg-white peer-focus:px-2 peer-focus:text-blue-600";

  return (
    <div className="min-h-screen bg-[#bfdaf9] font-sans text-gray-800 flex flex-col">
      <main className="flex-1 flex items-center justify-center p-4">
        <div className="bg-white w-full max-w-[500px] rounded-sm shadow-xl p-8 md:px-12 md:py-10 text-center relative">
          
          {step === 1 ? (
            /* --- STEP 1: EMAIL INPUT --- */
            <div className="animate-fade-in">
              <h2 className="text-2xl font-bold mb-8 text-black">Create Account</h2>
              <form onSubmit={handleSendOtp}>
                <div className="relative mb-6 text-left">
                  <div className="relative">
                    <input
                      type="email"
                      id="email"
                      className={inputClasses}
                      placeholder=" "
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                    <label htmlFor="email" className={labelClasses}>
                      Email Address
                    </label>
                  </div>
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full text-white bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-3 text-center mb-6 transition-colors"
                >
                  {loading ? "Sending OTP..." : "Continue"}
                </button>
              </form>

              {/* Social Login */}
              <div className="relative flex py-2 items-center mb-6">
                <div className="flex-grow border-t border-gray-300"></div>
                <span className="flex-shrink-0 px-2 text-gray-500 text-sm">OR</span>
                <div className="flex-grow border-t border-gray-300"></div>
              </div>

              {/* SOCIAL BUTTONS CONTAINER */}
              <div className="flex justify-center space-x-6 mb-6">
                
                {/* FACEBOOK BUTTON */}
                <FacebookLogin
                  appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                  onSuccess={async (response) => {
                    try {
                      const res = await axios.post(
                        SummaryApi.facebookLogin.url,
                        { accessToken: response.accessToken }
                      );
                      // Call the helper
                      await handleSocialAuthSuccess(res.data.token, "Facebook Signup");
                    } catch (err) {
                      console.error("Facebook API Error:", err);
                      toast.error("Facebook signup failed");
                    }
                  }}
                  onFail={(err) => {
                    console.log("FB ERROR:", err);
                    toast.error("Facebook Signup Failed");
                  }}
                  render={({ onClick }) => (
                    <button
                      type="button"
                      onClick={onClick}
                      className="w-10 h-10 flex items-center justify-center rounded-full hover:opacity-80 transition hover:scale-105"
                    >
                      <FaFacebook className="text-[#0163E0] text-4xl" />
                    </button>
                  )}
                />

                {/* GOOGLE BUTTON */}
                <button
                  type="button"
                  onClick={() => googleLogin()}
                  className="w-10 h-10 flex items-center justify-center rounded-full hover:opacity-80 transition hover:scale-105"
                >
                  <FcGoogle className="text-4xl" />
                </button>
              </div>

              <div className="text-sm text-gray-500">
                Already have an account? <Link to="/login" className="text-blue-600 font-semibold underline">Sign in</Link>
              </div>
            </div>
          ) : (
            /* --- STEP 2: OTP & PASSWORD (UNCHANGED) --- */
            <div className="animate-fade-in">
              <div className="flex justify-center mb-4">
                 <svg className="w-16 h-16 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"/></svg>
              </div>

              <h2 className="text-xl font-bold mb-2 text-black">OTP Verification</h2>
              <p className="text-xs text-gray-800 font-medium mb-1">
                Enter the OTP sent to {email}
              </p>
              <button onClick={() => setStep(1)} className="text-xs text-blue-500 font-medium hover:underline mb-6">
                Change Email
              </button>

              <form onSubmit={handleVerifyAndRegister}>
                {/* OTP Inputs */}
                <div className="flex justify-center gap-4 mb-6">
                  {otp.map((digit, index) => (
                    <input
                      key={index}
                      ref={(el) => (otpInputRefs.current[index] = el)}
                      type="text"
                      maxLength={1}
                      value={digit}
                      onChange={(e) => handleOtpChange(e.target.value, index)}
                      onKeyDown={(e) => handleOtpKeyDown(e, index)}
                      onPaste={(e) => handleOtpPaste(e, index)}
                      className="w-10 h-10 text-center text-xl font-bold text-gray-800 border-b-2 border-gray-400 focus:border-blue-600 focus:outline-none bg-transparent"
                    />
                  ))}
                </div>

                {/* Password Fields */}
                <div className="space-y-6 mb-6 text-left">
                  
                  {/* New Password */}
                  <div className="relative">
                     <div className="relative">
                       <input
                        type={showPassword ? "text" : "password"}
                        id="new-password"
                        className={`${inputClasses} pr-10`} 
                        placeholder=" "
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                       />
                       <label htmlFor="new-password" className={labelClasses}>
                         New Password
                       </label>
                       
                       <button
                          type="button"
                          onClick={() => setShowPassword(!showPassword)}
                          className="absolute inset-y-0 right-0 px-3 flex items-center text-gray-400 hover:text-blue-600 focus:outline-none z-20"
                       >
                          {showPassword ? <FaEyeSlash /> : <FaEye />}
                       </button>
                     </div>
                  </div>

                  {/* Confirm Password */}
                  <div className="relative">
                     <div className="relative">
                       <input
                        type={showConfirmPassword ? "text" : "password"}
                        id="confirm-password"
                        className={`${inputClasses} pr-10`}
                        placeholder=" "
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                       />
                       <label htmlFor="confirm-password" className={labelClasses}>
                         Confirm Password
                       </label>

                       <button
                          type="button"
                          onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                          className="absolute inset-y-0 right-0 px-3 flex items-center text-gray-400 hover:text-blue-600 focus:outline-none z-20"
                       >
                          {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                       </button>
                     </div>
                  </div>
                </div>

                <div className="text-xs text-gray-500 mb-6">
                  Didn't receive the OTP? <button type="button" onClick={handleResendOtp} className="text-blue-500 font-medium hover:underline">Resend OTP</button>
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full text-white bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-3 text-center mb-6 transition-colors"
                >
                  {loading ? "Verifying..." : "Confirm & Register"}
                </button>
              </form>
            </div>
          )}

          <div className="mt-8 text-[10px] md:text-[12px] text-gray-500">
            By proceeding, you acknowledge and accept Regeestex{' '}
            <Link 
              to="/terms-and-conditions" 
              target="_blank" 
              rel="noopener noreferrer"
              className="underline hover:text-black transition-colors font-medium"
            >
              Terms of Use
            </Link>
            {' '}and{' '}
            <Link 
              to="/privacy-policy" 
              target="_blank" 
              rel="noopener noreferrer"
              className="underline hover:text-black transition-colors font-medium"
            >
              Privacy Policy
            </Link>.
          </div>
        </div>
      </main>
    </div>
  );
};

export default SignUp;